export enum CustomerAccountType {
  KEY_ACCOUNT = 'key_account',
  VIP = 'vip',
  STANDARD = 'standard',
}
